var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0952b3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M559.1,35.8a32.1,32.1,0,0,0-32.9,1.6l-96,64-14.12,9.45a.16.16,0,0,0-.08.14V273a.16.16,0,0,0,.08.14l14.12,9.45,96,64A32,32,0,0,0,576,320V64A32,32,0,0,0,559.1,35.8ZM540.92,271.32a21.61,21.61,0,0,1-5.65,14.91,16.93,16.93,0,0,1-22.54,2.21l-54.42-39.71a.16.16,0,0,1,0-.07l-2.6-5.83a.09.09,0,0,1,0-.07V142.1a.09.09,0,0,1,0-.07l2.6-4.88s0-1,0-1l54.42-39.71c8.37-6.07,19.64-3.57,25.18,5.58a21.32,21.32,0,0,1,3,11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.11,290.84a48.81,48.81,0,0,1-48.71,48.75H92.7A48.81,48.81,0,0,1,44,290.84V96C44,69.15,68.26,47.28,98.1,47.28H292.87c21.45,0,43.32,21.87,43.32,48.74V290.84ZM320,0H64A64.06,64.06,0,0,0,0,64V320a64.06,64.06,0,0,0,64,64H320a64.06,64.06,0,0,0,64-64V64A64.06,64.06,0,0,0,320,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.67451a99f9f623d96c6c388e82f1660d.svg";
export { ForwardRef as ReactComponent };